import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
// import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdi', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#0C41B3',
        secondary: '#48B293',
        info: '#03A9F4',
      },
      dark: {
        primary: '#0C41B3',
        secondary: '#48B293',
        info: '#03A9F4',
      }
    },
  },
}

export default new Vuetify(opts)
